/**
 * @deprecated use same function from '@alilc/lowcode-utils' instead
 */
export function isJSExpression(data) {
  return data && data.type === 'JSExpression' && data.extType !== 'function';
}